<template>
  <section class="section">

    <b-breadcrumb :items="[
        { text: this.customerName, to: '/' },
        { text: 'Utenti' }
        ]">
    </b-breadcrumb>

    <div class="row">
      <div class="col">

        <div class="card">
          <div class="card-block">

            <table class="table striped table-hover" v-if="users.length">
                <thead>
                  <tr>
                    <th></th>
                    <th>Stato</th>
                    <th>Username</th>
                    <th>E-mail</th>
                    <th>Ruolo</th>
                    <th>Siti</th>
                    <th>Ultimo accesso</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-bind:key="model.id"  v-for="model in users" :class="'status-' + model.active">
                    <td>
                      <router-link :to="'/users/' + model.guid">
                        <font-awesome-icon icon="cogs" />
                      </router-link>
                    </td>
                    <td>
                      <button v-b-tooltip.hover v-on:click="toggle(model.guid)" v-if="model.active == 0" class="btn status-inactive" title="Attiva utente">
                        <font-awesome-icon icon="minus-circle" />
                      </button>
                      <button v-b-tooltip.hover v-on:click="toggle(model.guid)" v-else class="btn status-active" title="Disattiva utente">
                        <font-awesome-icon icon="circle" />
                      </button>
                    </td>
                    <td>{{ model.username }}</td>
                    <td>{{ model.email }}</td>
                    <td>{{ model.level | userLevel }}</td>
                    <td>
                      <span class="badge badge-secondary" v-for="site in model.sites" v-bind:key="site.id">{{ site.name }}</span>
                    </td>
                    <td>{{ model.lastLogin | formatDate }}</td>
                  </tr>
                </tbody>
              </table>

              <div v-else>
                <div class="alert alert-warning" role="alert">Nessun utente associato al cliente.</div>
              </div>
          </div>
        </div>

        <b-btn variant="primary" to="/users/new">
          <font-awesome-icon icon="plus" />
          Nuovo utente</b-btn>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import customerMenu from "../Menu.vue"

export default {
  name: "CustomerUsers",
  data() {
    return {
      users: []
    }
  },
  created() {
    this.$store.commit("loading")
    this.loadUsers();
    
    /*if(! this.$store.state.customers.selected.guid) {

    } else {
      this.$store.commit("loading")
      let guid = this.$store.state.customers.selected.guid
      this.$store.dispatch('users/listByCustomerGuid', guid).then( () => {
        this.$store.commit("stopLoading")
      })
    }*/
  },
  props: ['currentPage'],
  components: {
    customerMenu
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    isSuperAdmin() {
      return this.$store.state.user && this.$store.state.user.level == 1
    },
    customerName() {
      return this.user.customerName
    }
  },
  methods: {
    loadUsers() {
      this.$store.dispatch('users/list').then( (users) => {
        this.$store.commit("stopLoading")
        if(this.isSuperAdmin) {
          this.users = users.filter(u => ! u.superAdmin); 
        }          
      })
      
    },
    toggle(id) {
      this.$store.dispatch("users/toggle", { id }).then((response) => {
        this.$store.dispatch("customers/refresh", this.$store.state.customers.selected.guid)
        if(response.data == -1)
          Vue.toasted.show('Impossibile disattivare l\'unico Super Admin', { duration: 3000, icon : 'exclamation-triangle', theme: "bubble" })
        if(response.code == 1)
          Vue.toasted.show('Utente modificato', { duration: 3000, icon : 'check', theme: "bubble" })
      })
      this.loadUsers();
    }
  }
}
</script>

<style scoped>
.status-inactive {
  color:red;
}
.status-active {
  color:green;
}
.status-active:hover {
  color:red;
}
.status-inactive:hover {
  color:green;
}
.status-inactive,
.status-active {
  background: transparent;
}
tr.status-0 td {
  color: #aaa;
}
.badge {
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Users/Users.vue